/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admincredit_Colbalance2Inputs */

const zh_admincredit_colbalance2 = /** @type {(inputs: Admincredit_Colbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`余额`)
};

const en_admincredit_colbalance2 = /** @type {(inputs: Admincredit_Colbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balance`)
};

const es_admincredit_colbalance2 = /** @type {(inputs: Admincredit_Colbalance2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saldo`)
};

/**
* | output |
* | --- |
* | "Balance" |
*
* @param {Admincredit_Colbalance2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const admincredit_colbalance2 = /** @type {((inputs?: Admincredit_Colbalance2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admincredit_Colbalance2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_admincredit_colbalance2(inputs)
	if (locale === "en") return en_admincredit_colbalance2(inputs)
	return es_admincredit_colbalance2(inputs)
});
export { admincredit_colbalance2 as "adminCredit_colBalance" }